import ProgressBar from "@/components/ProgressBar";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import ROICalculator from "@/components/ROICalculator";
import TalkingWebsiteFeature from "@/components/TalkingWebsiteFeature";
import ServicesSection from "@/components/ServicesSection";
import WhyChooseUs from "@/components/WhyChooseUs";
import IndustriesSection from "@/components/IndustriesSection";
import GlobalClients from "@/components/GlobalClients";
import TestimonialsSection from "@/components/TestimonialsSection";
import HowItWorksSection from "@/components/HowItWorksSection";
import CaseStudyCards from "@/components/CaseStudyCards";
import CompareModels from "@/components/CompareModels";
import CompareCleaningRobots from "@/components/CompareCleaningRobots";
import AIMusicSection from "@/components/AIMusicSection";
import ROISnapshotSection from "@/components/ROISnapshotSection";
import IntegrationsSection from "@/components/IntegrationsSection";
import FAQSection from "@/components/FAQSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import ExitIntentPopup from "@/components/ExitIntentPopup";
import MobileStickyCTA from "@/components/MobileStickyCTA";
import DesktopStickyCTA from "@/components/DesktopStickyCTA";
import VoiceAIButton from "@/components/VoiceAIButton";
import UrgencyBanner from "@/components/UrgencyBanner";
import CTASection from "@/components/CTASection";
import SEO from "@/components/SEO";

const Index = () => {
  return (
    <>
      <SEO 
        title="Neil AI Global Solutions – AI Automation & PUDU Robotics Dealer"
        description="Go fully autonomous with Neil AI — offering robotics, AI voice automation, CRM systems & digital integration for businesses nationwide. Save up to 60% on labor costs."
        keywords="AI automation, PUDU robotics dealer, service robots, delivery robots, cleaning robots, voice automation, CRM integration, business automation, AI solutions, labor cost reduction"
      />
      <ProgressBar />
      <Navigation />
      
      <div 
        className="min-h-screen pt-24 sm:pt-28 md:pt-32 pb-4 md:pb-6 px-4 sm:px-6 md:px-4 relative overflow-hidden"
        style={{
          background: `
            radial-gradient(1400px 900px at 15% 5%, hsl(169 100% 25% / 0.15) 0%, transparent 55%),
            radial-gradient(1100px 700px at 85% 75%, hsl(43 62% 40% / 0.12) 0%, transparent 55%),
            linear-gradient(180deg, hsl(210 83% 8%) 0%, hsl(210 83% 4%) 100%)
          `
        }}
      >
        {/* Animated grid background */}
        <div 
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage: `
              linear-gradient(hsl(var(--primary) / 0.1) 1px, transparent 1px),
              linear-gradient(90deg, hsl(var(--primary) / 0.1) 1px, transparent 1px)
            `,
            backgroundSize: "50px 50px",
          }}
        />
        <main 
          className="max-w-7xl mx-auto border-neon rounded-[16px] p-4 sm:p-6 md:p-8 lg:p-10 relative glass-strong animate-fade-in"
          style={{
            boxShadow: "0 0 80px hsl(var(--primary) / 0.25), 0 8px 32px rgba(0, 0, 0, 0.6), inset 0 0 80px hsl(var(--primary) / 0.03)",
            transform: "translateZ(0)",
            animation: "fade-in 0.6s ease-out",
          }}
        >
          {/* Hero + ROI Section */}
          <div className="grid lg:grid-cols-[1.15fr_0.85fr] gap-3 md:gap-5 lg:gap-6 mb-0 md:mb-10 lg:mb-12">
            <HeroSection />
            
            <div id="neil-roi">
              <ROICalculator />
            </div>
          </div>

          {/* Urgency Banner */}
          <UrgencyBanner />

          {/* Talking Website Feature - HIGHLIGHTED */}
          <TalkingWebsiteFeature />

          {/* Services Section */}
          <ServicesSection />

          {/* Why Choose Us Section */}
          <WhyChooseUs />

          {/* CTA */}
          <CTASection variant="compact" />

          {/* How It Works Section */}
          <HowItWorksSection />

          {/* Testimonials Section */}
          <TestimonialsSection />

          {/* CTA */}
          <CTASection />

          {/* Industries Section */}
          <IndustriesSection />

          {/* Global Clients Section */}
          <GlobalClients />

          {/* Case Study Cards */}
          <CaseStudyCards />

          {/* CTA */}
          <CTASection variant="compact" />

          {/* Compare Models Section */}
          <CompareModels />

          {/* Compare Cleaning Robots Section */}
          <CompareCleaningRobots />

          {/* AI Music Section */}
          <AIMusicSection />

          {/* ROI Snapshot Section */}
          <ROISnapshotSection />

          {/* Integrations Section */}
          <IntegrationsSection />

          {/* FAQ Section */}
          <FAQSection />

          {/* Contact Section */}
          <ContactSection />

          {/* Footer */}
          <Footer />
        </main>
      </div>

      {/* Mobile Voice Widget */}
      <VoiceAIButton />

      {/* Mobile Sticky CTA */}
      <MobileStickyCTA />
      
      {/* Desktop Sticky CTA */}
      <DesktopStickyCTA />
      
      {/* Exit Intent Popup */}
      <ExitIntentPopup />
    </>
  );
};

export default Index;
